import {
	AfterContentInit,
	Component,
	inject,
	OnDestroy,
	QueryList,
	ViewChildren,
} from '@angular/core';
import { Validators } from '@angular/forms';
import { GroupButton } from '@componentes/public-button-group/public-button-group.component';
import { Estacao } from '@home/submodulos/dados-meteorologicos/interfaces/filtros-opcoes';
import {
	Microrregiao,
	PostosRelatorios,
} from '@home/submodulos/dados-meteorologicos/interfaces/tabela-relatorio';
import {
	FormularioRelatorio,
	INPUTS_RELATORIOS,
} from '@home/submodulos/dados-meteorologicos/interfaces/tipos-relatorios';
import { RelatoriosService } from '@home/submodulos/dados-meteorologicos/services/relatorios.service';
import { Select } from '@layout/interfaces/select';
import {
	alinharDado,
	isNotNuloOuUndefined,
	numberToBrNumber,
	numberToBrNumberTables,
	renderNumeroBR,
	verificaSePDFEAdicionaNaTabela,
} from '@utils';
import { DateTimeUtils } from '@utils/datetime-util';
import { DocumentExporter } from '@utils/document-exporter';
import { NumberUtils } from '@utils/number-utils';
import * as pdfseira from '@utils/pdf-seira';
import { formatISO } from 'date-fns';
import { ToastrService } from 'ngx-toastr';
import * as pdfMake from 'pdfmake/build/pdfmake';
import { Subject } from 'rxjs';
import * as ExcelTable from 'mr-excel';
import { DataModel } from 'mr-excel';
import moment from 'moment';
import { corrigeDuplicacaoNome } from '../../../utils';
import { ADTColumns } from 'angular-datatables/src/models/settings';
import { PublicTableComponent } from '@componentes/public-table/public-table.component';

@Component({
	selector: 'seira-pluviometro-tabela-desvios-mensais-anuais',
	templateUrl: './pluviometro-tabela-desvios-mensais-anuais.component.html',
	styleUrls: ['./pluviometro-tabela-desvios-mensais-anuais.component.scss'],
})
export class PluviometroTabelaDesviosMensaisAnuaisComponent
	implements OnDestroy, AfterContentInit
{
	inputs = inject(INPUTS_RELATORIOS);
	private _destroyed = new Subject();
	postos: PostosRelatorios[] = [];
	estacoes: Estacao[] = [];
	microrregioes!: Select<string>[];
	carregandoRelatorio = true;
	dadosTabelaRelatorio: Microrregiao[] = [];
	botoesDeExportacao: GroupButton[] = [
		{
			label: '.pdf',
			size: 'small',
			icon: 'ph-file-pdf',
			onClick: () => this.exportarPDF(),
		},
		{
			label: '.csv',
			size: 'small',
			icon: 'ph-file-csv',
			onClick: () => this.exportarCSV(),
		},
		{
			label: '.txt',
			size: 'small',
			icon: 'ph-file-text',
			onClick: () => this.exportarTXT(),
		},
		{
			label: '.xlsx',
			size: 'small',
			icon: 'ph-file-xls',
			onClick: () => this.exportarXLSX(),
			/*
				// {
				//   data: 'precipitacaoObservadaMensal',
				//   title: 'Obs. mensal (mm)',
				//   type: 'number',
				//   className: 'text-center',
				//   render: (data: string) => renderNumeroBR(data, 1),
				// },
				// {
				//   data: 'climatologiaMensal',
				//   title: 'Climatologia mensal (mm)',
				//   type: 'number',
				//   className: 'text-center',
				//   render: (data: string) => renderNumeroBR(data, 1),
				// },
				// {
				//   data: 'desvioAbsolutoMensal',
				//   title: 'Desv. mensal (mm)',
				//   type: 'number',
				//   className: 'text-center',
				//   render: (data: string) => renderNumeroBR(data, 1),
				// },
				// {
				//   data: 'desvioPercentualMensal',
				//   title: 'Desv. mensal (%)',
				//   type: 'number',
				//   className: 'text-center',
				//   render: (data: string) => renderNumeroBR(data, 1),
				// },
				// {
				//   data: 'precipitacaoObservadaAnual',
				//   title: 'Obs. anual (mm)',
				//   type: 'number',
				//   className: 'text-center',
				//   render: (data: string) => renderNumeroBR(data, 1),
				// },
				// {
				//   data: 'climatologiaAnual',
				//   title: 'Climatologia anual (mm)',
				//   type: 'number',
				//   className: 'text-center',
				//   render: (data: string) => renderNumeroBR(data, 1),
				// },
				// {
				//   data: 'desvioAbsolutoAnual',
				//   title: 'Desv. anual (mm)',
				//   type: 'number',
				//   className: 'text-center',
				//   render: (data: string) => renderNumeroBR(data, 1),
				// },
				// {
				//   data: 'desvioPercentualAnual',
				//   title: 'Desv. anual (%)',
				//   type: 'number',
				//   className: 'text-center',
				//   render: (data: string) => renderNumeroBR(data, 1),
				// },
				exportarMultiplasTabelasEmUnicoXLSX({
					tabelas: this.tabelas!.toArray(),
					tituloTabela: `Totais e desvios mensais e anuais - ${this.periodoTitulo}`,
					indiceColunaIdentificadora: 1,
					colunasAEsquerda: [0],
					// TODO: colocar configurações da coluna
					configsColunas: [
						...configsColunasCoordenadas,
						...[
							'desvioPercentualAnual',
							'desvioAbsolutoAnual',
							'climatologiaAnual',
							'precipitacaoObservadaAnual',
							'desvioPercentualMensal',
							'desvioAbsolutoMensal',
							'climatologiaMensal',
							'precipitacaoObservadaMensal',
						].map(e => ({
							casasDecimais: 1,
							coluna: e,
							usarRender: true,
						})),
					],
					colunaIdentificadora: {
						title: 'Microrregiao',
						data: 'microrregiao',
						className: 'text-center',
						type: 'text',
					},
				}),
			*/
		},
	];

	@ViewChildren('tabelaDesviosMensaisAnuais')
	tabelas!: QueryList<PublicTableComponent>;

	descricaoRelatorio =
		'Define-se como totais e desvios mensais e anuais a quantidade total de precipitação acumulada comparada à média histórica, dados em (mm) e (%).';

	periodoTitulo = '';
	constructor(
		private relatoriosService: RelatoriosService,
		private toastr: ToastrService
	) {}

	colunas: ADTColumns[] = [
		{
			data: 'municipioPosto', // porque vamos montar manualmente
			title: 'Município/Posto',
			type: 'string',
			className: 'text-left',
		},
		{
			data: 'latitude',
			title: 'Latitude',
			type: 'number',
			className: 'text-center',
			render: (data: string) => renderNumeroBR(data, 4),
		},
		{
			data: 'longitude',
			title: 'Longitude',
			type: 'number',
			className: 'text-center',
			render: (data: string) => renderNumeroBR(data, 4),
		},
		{
			data: 'precipitacaoObservadaMensal',
			title: 'Obs. mensal (mm)',
			type: 'number',
			className: 'text-center',
			render: (data: string) => renderNumeroBR(data, 1),
		},
		{
			data: 'climatologiaMensal',
			title: 'Climatologia mensal (mm)',
			type: 'number',
			className: 'text-center',
			render: (data: string) => renderNumeroBR(data, 1),
		},
		{
			data: 'desvioAbsolutoMensal',
			title: 'Desv. mensal (mm)',
			type: 'number',
			className: 'text-center',
			render: (data: string) => renderNumeroBR(data, 1),
		},
		{
			data: 'desvioPercentualMensal',
			title: 'Desv. mensal (%)',
			type: 'number',
			className: 'text-center',
			render: (data: string) => renderNumeroBR(data, 1),
		},
		{
			data: 'precipitacaoObservadaAnual',
			title: 'Obs. anual (mm)',
			type: 'number',
			className: 'text-center',
			render: (data: string) => renderNumeroBR(data, 1),
		},
		{
			data: 'climatologiaAnual',
			title: 'Climatologia anual (mm)',
			type: 'number',
			className: 'text-center',
			render: (data: string) => renderNumeroBR(data, 1),
		},
		{
			data: 'desvioAbsolutoAnual',
			title: 'Desv. anual (mm)',
			type: 'number',
			className: 'text-center',
			render: (data: string) => renderNumeroBR(data, 1),
		},
		{
			data: 'desvioPercentualAnual',
			title: 'Desv. anual (%)',
			type: 'number',
			className: 'text-center',
			render: (data: string) => renderNumeroBR(data, 1),
		},
	];

	ngAfterContentInit(): void {
		const dataAjustada = moment().subtract(1, 'month').endOf('month').toDate();
		setTimeout(() => {
			this.inputs.form.get(FormularioRelatorio.PERIODO)?.setValue(dataAjustada);
		}, 0);
	}

	gerarRelatorio() {
		const periodo = this.inputs.form.get('periodo')?.value;
		if (this.inputs.form.invalid || !periodo || !this.postos.length) {
			return;
		}
		this.inputs.setLoading(true);
		this.carregandoRelatorio = true;
		this.periodoTitulo = DateTimeUtils.formatarDataPeriodo(
			periodo,
			'',
			'mensal',
			true
		);

		this.relatoriosService
			.buscarRelatorioPluviometricosDoEstado(
				formatISO(new Date(periodo)),
				formatISO(new Date(periodo))
			)
			.subscribe({
				next: pluviometricos => {
					this.dadosTabelaRelatorio = (pluviometricos.dadosMicrorregiao || [])
						.map(dMicro => {
							if (!dMicro.postos || dMicro.postos.length === 0) {
								// ignora se não há postos
								return null;
							}

							dMicro.postos = dMicro.postos.map(p => ({
								municipioPosto: corrigeDuplicacaoNome(
									`${p.municipio}/${p.nomePosto}`
								),
								microrregiao: dMicro.nomeMicrorregiao,
								...p,
							}));

							return {
								...dMicro,
								dadosPorMunicipio: dMicro.postos.map(dMun => ({
									...dMun,
									municipioPosto: corrigeDuplicacaoNome(
										`${dMun.municipio}/${dMun.nomePosto}`
									),
									MunicipiosPosto: corrigeDuplicacaoNome(
										`${dMun.municipio}/${dMun.nomePosto}`
									),
								})),
							};
						})
						.filter(Boolean) as Microrregiao[];
					this.relatoriosService.atualizaVisibilidadeBotoesExportacao(
						this.dadosTabelaRelatorio
					); // remove os nulls e faz type assertion
					this.carregandoRelatorio = false;
					this.inputs.setLoading(false);
				},
				error: () => {
					this.carregandoRelatorio = false;
					this.inputs.setLoading(false);
					this.toastr.error('Ocorreu um erro ao gerar o relatório');
				},
				complete: () => {
					this.carregandoRelatorio = false;
					this.inputs.setLoading(false);
				},
			});
	}

	setValidators() {
		this.inputs.form
			.get(FormularioRelatorio.PERIODO)
			?.setValidators(Validators.required);
	}

	ngOnDestroy() {
		this.inputs.form.get(FormularioRelatorio.PERIODO)?.clearValidators();
	}

	formatNumber(value: number): string {
		return isNotNuloOuUndefined(value)
			? String(numberToBrNumber(value, 1))
			: '-';
	}

	generateTableData(
		dadoRelatorio: Microrregiao,
		isPdf: boolean,
		dividoPorMicrorregiao = true
	) {
		const tableData: any[][] = [];
		const colunas: any[] = [];

		colunas.push(
			{ text: 'Município/Posto', fillColor: '#DCDCDC', style: 'alignCenter' },
			{ text: 'Latitude', fillColor: '#DCDCDC', style: 'alignCenter' },
			{ text: 'Longitude', fillColor: '#DCDCDC', style: 'alignCenter' },
			{ text: 'Obs. mensal (mm)', fillColor: '#DCDCDC', style: 'alignCenter' },
			{
				text: 'Climatologia mensal (mm)',
				fillColor: '#DCDCDC',
				style: 'alignCenter',
			},
			{ text: 'Desv. mensal (mm)', fillColor: '#DCDCDC', style: 'alignCenter' },
			{ text: 'Desv. mensal (%)', fillColor: '#DCDCDC', style: 'alignCenter' },
			{ text: 'Obs. anual (mm)', fillColor: '#DCDCDC', style: 'alignCenter' },
			{
				text: 'Climatologia anual (mm)',
				fillColor: '#DCDCDC',
				style: 'alignCenter',
			},
			{ text: 'Desv. anual (mm)', fillColor: '#DCDCDC', style: 'alignCenter' },
			{ text: 'Desv. anual (%)', fillColor: '#DCDCDC', style: 'alignCenter' }
		);

		if (dividoPorMicrorregiao) {
			verificaSePDFEAdicionaNaTabela(tableData, colunas, isPdf);
		}

		dadoRelatorio.postos.forEach(dado => {
			const row: any[] = [
				corrigeDuplicacaoNome(`${dado.municipio}/${dado.nomePosto}`),
			];
			if (!dividoPorMicrorregiao) {
				row.push(alinharDado(dadoRelatorio.nomeMicrorregiao, isPdf));
			}
			row.push(
				alinharDado(numberToBrNumberTables(dado.latitude, 4), isPdf),
				alinharDado(numberToBrNumberTables(dado.longitude, 4), isPdf),
				alinharDado(numberToBrNumberTables(dado.climatologiaMensal, 1), isPdf),
				alinharDado(
					numberToBrNumberTables(dado.precipitacaoObservadaMensal, 1),
					isPdf
				),
				alinharDado(
					numberToBrNumberTables(dado.desvioAbsolutoMensal, 1),
					isPdf
				),
				alinharDado(
					numberToBrNumberTables(dado.desvioPercentualMensal, 1),
					isPdf
				),
				alinharDado(numberToBrNumberTables(dado.climatologiaAnual, 1), isPdf),
				alinharDado(
					numberToBrNumberTables(dado.precipitacaoObservadaAnual, 1),
					isPdf
				),
				alinharDado(numberToBrNumberTables(dado.desvioAbsolutoAnual, 1), isPdf),
				alinharDado(
					numberToBrNumberTables(dado.desvioPercentualAnual, 1),
					isPdf
				)
			);
			tableData.push(row);
		});
		return tableData;
	}

	retornarPluviometriaEstadoParaXLSX(dadoRelatorio: Microrregiao) {
		const tableData: any[] = [];

		dadoRelatorio.postos.forEach(dado => {
			tableData.push({
				municipioPosto: corrigeDuplicacaoNome(
					`${dado.municipio}/${dado.nomePosto}`
				),
				microrregiao: dadoRelatorio.nomeMicrorregiao,
				latitude:
					dado.latitude == null
						? '-'
						: NumberUtils.getIgnorandoCasasDecimais(dado.latitude, 4),
				longitude:
					dado.longitude == null
						? '-'
						: NumberUtils.getIgnorandoCasasDecimais(dado.longitude, 4),
				mediaMes:
					dado.climatologiaMensal == null
						? '-'
						: NumberUtils.getIgnorandoCasasDecimais(dado.climatologiaMensal, 1),
				valorObservadoMes:
					dado.precipitacaoObservadaMensal == null
						? '-'
						: NumberUtils.getIgnorandoCasasDecimais(
								dado.precipitacaoObservadaMensal,
								1
						  ),
				desvioMes:
					dado.desvioAbsolutoMensal == null
						? '-'
						: NumberUtils.getIgnorandoCasasDecimais(
								dado.desvioAbsolutoMensal,
								1
						  ),
				desvioPercentualMes:
					dado.desvioPercentualMensal == null
						? '-'
						: NumberUtils.getIgnorandoCasasDecimais(
								dado.desvioPercentualMensal,
								1
						  ),
				mediaAno:
					dado.climatologiaAnual == null
						? '-'
						: NumberUtils.getIgnorandoCasasDecimais(dado.climatologiaAnual, 1),
				valorObservadoAno:
					dado.precipitacaoObservadaAnual == null
						? '-'
						: NumberUtils.getIgnorandoCasasDecimais(
								dado.precipitacaoObservadaAnual,
								1
						  ),
				desvioAno:
					dado.desvioAbsolutoAnual == null
						? '-'
						: NumberUtils.getIgnorandoCasasDecimais(
								dado.desvioAbsolutoAnual,
								1
						  ),
				desvioPercentualAno:
					dado.desvioPercentualAnual == null
						? '-'
						: NumberUtils.getIgnorandoCasasDecimais(
								dado.desvioPercentualAnual,
								1
						  ),
			});
		});

		return tableData;
	}

	retornarPluviometriaEstadoParaXLSXAux() {
		const tableDataAux: any[] = [];

		this.dadosTabelaRelatorio.forEach(dadoRelatorio => {
			const table = this.retornarPluviometriaEstadoParaXLSX(dadoRelatorio);
			tableDataAux.push(...table);
		});

		return tableDataAux;
	}

	async exportarPDF() {
		const documentDefinition: any = await pdfseira.documentDefinitions(
			'landscape'
		);

		documentDefinition.pageOrientation = 'landscape';

		documentDefinition.content.push({
			text: `Totais e desvios mensais e anuais - ${this.periodoTitulo}`,
			fontSize: 12,
			alignment: 'center',
			margin: [0, 10],
		});

		if (!this.dadosTabelaRelatorio.length) {
			documentDefinition.content.push({
				text: 'Nenhum dado encontrado na tabela',
				alignment: 'center',
				fontSize: 10,
				margin: [0, 10],
			});
		}

		this.dadosTabelaRelatorio.forEach(dadoRelatorio => {
			const tableData = this.generateTableData(dadoRelatorio, true);
			documentDefinition.content.push(
				{
					text: `Microrregião ${dadoRelatorio.nomeMicrorregiao}`,
					fontSize: 12,
					margin: [0, 10],
				},
				{
					table: {
						body: tableData,
						layout: {
							noWrap: false,
							fontSize: 5,
						},
					},
				}
			);
		});
		const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
		setTimeout(() => {
			pdfDocGenerator.download(
				`relatorio-desvios-mensais-anuais-${this.periodoTitulo}`
			);
		}, 100);
		return pdfDocGenerator.open();
	}

	async exportarCSV() {
		const tableData: any[][] = [];
		const colunas: any[] = [];

		colunas.push(
			'Município/Posto',
			'Microrregião',
			'Latitude',
			'Longitude',
			'Obs. mensal (mm)',
			'Climatologia mensal (mm)',
			'Desv. mensal (mm)',
			'Desv. mensal (%)',
			'Obs. anual (mm)',
			'Climatologia anual (mm)',
			'Desv. anual (mm)',
			'Desv. anual (%)'
		);
		tableData.push(colunas);

		this.dadosTabelaRelatorio.forEach(dadoRelatorio => {
			const table = this.generateTableData(dadoRelatorio, false, false);
			tableData.push(...table);
		});
		DocumentExporter.gerarCSV(
			tableData,
			`relatorio-desvios-mensais-anuais-${this.periodoTitulo}`
		);
	}

	async exportarTXT() {
		let txtData = '';

		this.dadosTabelaRelatorio.forEach(microrregiao => {
			txtData += `Microrregião: ${microrregiao.nomeMicrorregiao} \n\n`;

			microrregiao.postos.forEach(dado => {
				txtData +=
					`Município/Posto: ${corrigeDuplicacaoNome(
						`${dado.municipio}/${dado.nomePosto}`
					)} \n` +
					`Latitude: ${numberToBrNumberTables(dado.latitude, 4)} \n` +
					`Longitude: ${numberToBrNumberTables(dado.longitude, 4)} \n` +
					`Obs. mensal (mm): ${numberToBrNumberTables(
						dado.precipitacaoObservadaMensal,
						1
					)} \n` +
					`Climatologia mensal (mm): ${numberToBrNumberTables(
						dado.climatologiaMensal,
						1
					)} \n` +
					`Desv. mensal (mm): ${numberToBrNumberTables(
						dado.desvioAbsolutoMensal,
						1
					)} \n` +
					`Desv. mensal (%): ${numberToBrNumberTables(
						dado.desvioPercentualMensal,
						1
					)} \n` +
					`Obs. anual (mm): ${numberToBrNumberTables(
						dado.precipitacaoObservadaAnual,
						1
					)} \n` +
					`Climatologia anual (mm): ${numberToBrNumberTables(
						dado.climatologiaAnual,
						1
					)} \n` +
					`Desv. anual (mm): ${numberToBrNumberTables(
						dado.desvioAbsolutoAnual,
						1
					)} \n` +
					`Desv. anual (%): ${numberToBrNumberTables(
						dado.desvioPercentualAnual,
						1
					)} \n\n`;
			});
		});

		DocumentExporter.gerarTXT(
			txtData,
			`relatorio-desvios-mensais-anuais-${this.periodoTitulo}`
		);
	}

	exportarXLSX() {
		const colorPalette = {
			c1: '2C3639',
			c2: 'FFFFFF',
			c3: '000000',
			c4: 'EEEEEE',
		};
		const rowStyle = {
			backgroundColor: colorPalette.c2,
			color: colorPalette.c3,
			alignment: {
				horizontal: 'center',
				vertical: 'center',
			} as DataModel.AlignmentOption,
		};
		const rowStyleDecimal1 = {
			...rowStyle,
			format: 'num_sep_1',
		};
		const rowStyleDecimal4 = {
			...rowStyle,
			format: 'float_4',
		};
		const headerStyle = {
			backgroundColor: colorPalette.c4,
			color: colorPalette.c1,
			bold: true,
			alignment: {
				horizontal: 'center',
				vertical: 'center',
				wrapText: 1,
			} as DataModel.AlignmentOption,
		};
		const headerStyleLeft = {
			backgroundColor: colorPalette.c4,
			color: colorPalette.c1,
			bold: true,
			alignment: {
				horizontal: 'left',
				vertical: 'center',
			} as DataModel.AlignmentOption,
		};
		const rowStyleLeft = {
			backgroundColor: colorPalette.c2,
			color: colorPalette.c3,
			alignment: {
				horizontal: 'left',
				vertical: 'center',
			} as DataModel.AlignmentOption,
		};
		const title = {
			backgroundColor: colorPalette.c2,
			whiteSpace: 'pre',
			color: colorPalette.c3,
			bold: true,
			alignment: {
				horizontal: 'center',
				vertical: 'center',
				wrapText: 1,
			} as DataModel.AlignmentOption,
		};
		const headers = [
			{
				label: 'municipioPosto',
				text: 'Município/Posto',
				size: 24,
			},
			{
				label: 'microrregiao',
				text: 'Microrregião',
				size: 24,
			},
			{ label: 'latitude', text: 'Latitude', size: 24 },
			{ label: 'longitude', text: 'Longitude', size: 24 },
			{ label: 'valorObservadoMes', text: 'Obs. mensal (mm)', size: 24 },
			{ label: 'mediaMes', text: 'Climatologia mensal (mm)', size: 24 },
			{ label: 'desvioMes', text: 'Desv. mensal (mm)', size: 24 },
			{ label: 'desvioPercentualMes', text: 'Desv. mensal (%)', size: 24 },
			{ label: 'valorObservadoAno', text: 'Obs. anual (mm)', size: 24 },
			{ label: 'mediaAno', text: 'Climatologia anual (mm)', size: 24 },
			{ label: 'desvioAno', text: 'Desv. anual (mm)', size: 24 },
			{ label: 'desvioPercentualAno', text: 'Desv. anual (%)', size: 24 },
		];

		const dataExcel = {
			styles: {
				headerStyleLeft,
				headerStyle,
				rowStyle,
				rowStyleDecimal1,
				rowStyleDecimal4,
				rowStyleLeft,
				title,
			},
			sheet: [
				{
					shiftTop: 3,
					images: [
						{
							url: 'assets/images/cabecalho/cabeçalho_excel.png',
							from: 'A1',
							to: 'C3',
						},
					],
					styleCellCondition(
						data: any,
						object: any,
						rowIndex: number,
						colIndex: number,
						fromHeader: boolean,
						styleKeys: string[]
					) {
						if (data?.label) {
							return 'headerStyle';
						}
						if (colIndex === 0) {
							return 'rowStyleLeft';
						}
						if (colIndex === 2 || colIndex === 3) {
							return 'rowStyleDecimal4';
						}
						if (colIndex >= 4) {
							return 'rowStyleDecimal1';
						}
						return 'rowStyle';
					},
					headers: headers,
					data: this.retornarPluviometriaEstadoParaXLSXAux(),
					convertStringToNumber: true,
					title: {
						consommeRow: 3,
						consommeCol: 3,
						text: `Totais e desvios mensais e anuais - ${this.periodoTitulo}`,
						styleId: 'title',
					},
				},
			],
			fileName: `relatorio-totais-desvios-mensais-anuais-${this.periodoTitulo}`,
		};

		ExcelTable.generateExcel(dataExcel);
	}
}
